
<div class="footer-action">
  <button class="btn btn-outline-primary" :disabled="!unsavedChanges || selectedColumns.length === 0" @click="cancelUpdate">
    Cancel
  </button>
  <div class="float-right">
    <v-tooltip v-if="tooltipMessage" top open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <button class="btn btn-primary" :disabled="!unsavedChanges || selectedColumns.length === 0" v-bind="attrs" v-on="on"
          @click="saveReportTemplate">
          Update Report
        </button>
      </template>
      <span>{{ tooltipMessage }}</span>
    </v-tooltip>

    <button v-else class="btn btn-primary" :disabled="!unsavedChanges || selectedColumns.length === 0" @click="updateReport">
      Update Report
    </button>
    <button class="btn btn-outline-primary ml-2" @click="previewReport">
      Go to Preview
    </button>
  </div>
</div>
